<template>
  <div class="treebox">
    <div class="ipt">
      <!-- <p class="el-icon-close" @click="close"></p> -->
      <el-input v-model="queryval" placeholder="输入坝名关键字搜索" class="querys" @change="changeFun" clearable></el-input>
    </div>
    <!-- <transition name="el-zoom-in-top">
			<div class="treeClass">
				<el-tree v-show="treeShow" :default-expand-all='true' :expand-on-click-node="false" ref="tree" :filter-node-method="filterNode" :data="treedata" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
			</div>
		</transition> -->
  </div>
</template>

<script>
import {
  ydbtree,
  selectYdbInfo
} from '@/api/api.js'

export default {
  data() {
    return {
      queryval: '',
      // treeShow: false,
      reginCode: '',
      treedata: [],
      loading: false
      // defaultProps: {
      // 	children: 'children',
      // 	label: 'city',
      // },
    }
  },
  mounted() {
    // let params = {}
    // ydbtree(params).then((res) => {
    // 	console.log('111111111111111', res.data)
    // 	this.treedata = res.data
    // })
  },
  methods: {
    changeFun(value) {
      // console.log(value)
      this.$emit('obj', value)
      // if (value !== '') {
      //   let params = {
      //     allowPage: false,
      //     ydbCode: this.$store.state.nowxingzhengCode,
      //     ydbName: value
      //   };
      //   selectYdbInfo(params).then(res => {
      //     this.treedata = res.data;
      //     this.$emit("obj", this.treedata);
      //   })
      // } else {
      //   this.treedata = [];
      //   this.$emit("obj", this.treedata);
      // }
    },

    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        const params = {
          allowPage: false,
          ydbCode: this.$store.state.nowxingzhengCode,
          ydbName: query
        }
        selectYdbInfo(params).then(res => {
          this.treedata = res.data
          this.loading = false
        })
      } else {
        this.treedata = []
      }
    },

    remoteChange(value) {
      // let data;
      // if (this.treedata != '') {
      //   for (let i = 0; i < this.treedata.length; i++) {
      //     if (this.treedata[i].ydbCode == value) {
      //       data = this.treedata[i];
      //     }
      //   }
      // }
      this.$emit('obj', this.treedata)
      // this.$emit("queryDatas", data);
      // this.$store.commit('queryData', data); //token
      this.treedata = []
    },

    close() {
      this.queryval = ''
      this.$emit('close', '')
    }
    // queryfocus() {
    // 	this.treeShow = true;
    // },
    // valblur() {
    // 	let _this = this;
    // 	setTimeout(function() {
    // 	}, 400)
    // },
    // handleNodeClick(data) {
    // 	this.queryval = data.city;
    // 	this.$emit("obj", data);
    // 	let _this = this;
    // 	setTimeout(function() {
    // 		_this.treeShow = false;
    // 	}, 400)
    // },
    // filterNode(value, data) {
    // 	if(!value) return true;
    // 	return data.city.indexOf(value) !== -1;
    // },
    // mouseLeave() {
    // 	let _this = this;
    // 	setTimeout(function() {
    // 		_this.treeShow = false;
    // 		_this.$refs.input_blur.blur()
    // 	}, 200)
    // },
  },
  computed: {
    // nowxingzhengCodes() {
    //   return this.$store.state.nowxingzhengCode; //需要监听的数据
    // },
  },
  watch: {
    // nowxingzhengCodes(newVal, oldVal) {
    //   this.reginCode = newVal;
    // },
    // queryval(val) {
    // 	this.$refs.tree.filter(val)
    // }
  }
}
</script>

<style scoped>
.treebox {
  width: 220px;
  position: relative;
  float: right;
  margin-right: 10px;
  margin-top: 10px;
}

.ipt {
  width: 100%;
  height: 30px;
  display: block;
  margin: 0 auto;
  position: relative;
}

.ipt p {
  position: absolute;
  right: 12px;
  top: 0px;
  font-size: 14px;
  color: #606266;
  z-index: 100;
  line-height: 30px;
  font-weight: 600;
  cursor: pointer;
}

.querys {
  height: 30px;
}

>>>.el-input__inner {
  height: 30px;
  line-height: 30px;
  color: #606266;
  padding-left: 10px;
  font-size: 14px;
}

.treeClass {
  position: absolute;
  top: 30px;
  left: 0px;
  right: 0px;
  z-index: 3000;
  max-height: 600px;
  overflow: auto;
  box-shadow: 0 0 10px #e0e0e0;
  border-radius: 5px 5px 10px 10px;
}
</style>
